import {
    Backdrop,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    makeStyles,
    Typography,
} from "@material-ui/core";
import Config from "Config";
import jwtDecode from "jwt-decode";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";
import sysend from "sysend";
import LinkUpDialog from "../../component/LinkUpDialog/LinkUpDialog";
import iamsmartIconDark from "../../images/iamsmart-icon-dark.png";
import {
    getIamsmartProfileDone,
    parseToken,
    resetApplicantFormList,
    resetProfile,
    resetToken,
    setToken,
    setUserRole,
} from "../../redux/action";
import { send, sendV20 } from "../../SendRequest";
import { isIOS, isNotEmpty } from "../../Utils";

const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.iamSmart.main,
        },
        height: "3rem",
        fontSize: "1.11em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            height: "3.5rem",
            fontSize: "1em", // 37% of height, min 12px
            minHeight: "3.5rem",
            minWidth: "14rem",
        },
    },
}));

export default function IamsmartLogin() {
    const query = useLocation().search;
    const dispatch = useDispatch();
    const iamSmartBtnClasses = iamSmartBtnStyle();
    const navigate = useNavigate();

    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const [authCode, setAuthCode] = useState("");
    const [ticketID, setTicketID] = useState("");
    const [qrLinkURL, SetQrLinkURL] = useState("");
    const [step, setStep] = useState("qrLink");
    const [openLinkUp, setOpenLinkUp] = useState(false);
    const [hasLinkUp, setHasLinkUp] = useState(false);
    const [openLoginSuccess, setOpenLoginSuccess] = useState(false);
    const [noSigning, setNoSigning] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [openID, setOpenID] = useState("");

    const onLogin = () => {
        navigate("/main");
    };

    const onCancel = () => {
        setStep("qrLink");
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
        setAuthCode("");
        SetQrLinkURL("");
        // if (isObjectNotEmpty(iamsmartProfile)) {
        //     setOpenLinkUp(true);
        // }
        //setStep("qrLink");
    };
    const onGetProfile = (authCode) => {
        const headersV20 = {
            code: authCode,
            isDirectLoginV2: true,
        };

        const optionV20 = {
            url: "/iamsmartedbv2/edbeform/auth/response",
            method: "POST",
            header: headersV20,
        };

        dispatch(sendV20("GET_IAMSMART_PROFILE", optionV20))
            .then((response) => {
                return response.json();
            })
            .then((result) => {
                result = jwtDecode(result)?.data;

                if (
                    result.error ||
                    //result.userType != "sign"
                    (result.userType != "sign" && result.userType != "default")
                ) {
                    setOpen(true);
                    setNoSigning(true);
                    setStep("getProfileResult");
                } else {
                    dispatch(
                        getIamsmartProfileDone(
                            result.accessToken,
                            result.openID,
                            "" //result.ticketID
                        )
                    );
                    setToken;
                    // handleClose();
                    const option = {
                        url: `${Config.CONTENT_PATH}/iamsmartLoginByOpenID`,
                        method: "POST",
                        body: JSON.stringify({ openID: result.openID }),
                    };
                    console.log("result: ", result);
                    setOpenID(result.openID);
                    dispatch(send("IAMSMART_LOGIN", option))
                        .then((response) => {
                            return response.json();
                        })
                        .then((loginResult) => {
                            if (loginResult.linked) {
                                setCookie("token", loginResult.token, {
                                    path: `${Config.CONTENT_PATH}`,
                                    maxAge: 3600,
                                    secure: true,
                                });
                                dispatch(setToken(loginResult));
                                dispatch(parseToken({ token: loginResult.token }));
                                dispatch(setUserRole(loginResult.role));
                                setHasLinkUp(true);
                                setOpenLoginSuccess(true);

                                // const theName = `https://${Config.DOMAIN}${Config.CONTENT_PATH}/main`
                                // window.location.href = theName;
                            } else {
                                setOpenLinkUp(true);
                            }
                        });
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    useEffect(() => {
        if (isIOS()) {
            if (localStorage) {
                localStorage.setItem("IamsmartLogin", query);
            }
        } else {
            sysend.broadcast("IamsmartLogin", query);
        }

        // Only reset token and profile when running in iAM Smart In-App Browser
        const isInAppBrowser = navigator.userAgent.includes(
            "iAM Smart In-App Browser"
        );

        if (isInAppBrowser) {
            removeCookie("token", {
                path: `${Config.CONTENT_PATH}`,
            });
            dispatch(resetToken());
            dispatch(resetProfile());
            dispatch(resetApplicantFormList());
        }

        const data = new URLSearchParams(query);
        const code = data.get("code");
        const RefID = data.get("RefID");

        if (isNotEmpty(RefID)) {
            onGetProfile(code);
        } else {
            window.close();
        }
    }, []);

    useEffect(() => {
        console.log("openLoginSuccess: ", openLoginSuccess);
        const data = new URLSearchParams(query);
        const lang = data.get("lang");

        if (lang !== undefined && lang !== null) {
            i18n.changeLanguage(lang);
        }

        if (openLoginSuccess) {
            navigate("/main");
        }
    }, [openLoginSuccess]);

    return (
        <>
            IamsmartLogin
            <LinkUpDialog
                open={openLinkUp}
                openID={openID}
                onLinkUp={() => {
                    setOpenLinkUp(false);
                    setOpenLoginSuccess(true);
                }}
                onClose={() => {
                    setOpenLinkUp(false);
                }}
            />
            <LinkUpDialog
                open={openLinkUp}
                openID={openID}
                onLinkUp={() => {
                    setOpenLinkUp(false);
                    setOpenLoginSuccess(true);
                }}
                onClose={() => {
                    setOpenLinkUp(false);
                }}
            />
            <Dialog
                // onClose={handleClose}
                aria-labelledby="simple-dialog-title"
                open={false}
            >
                <DialogTitle id="simple-dialog-title">
                    {t("common.iamsmart.login.success")}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {hasLinkUp && t("common.iamsmart.login.success")}
                        {!hasLinkUp &&
                            t("common.iamsmart.linkup.linkupSuccess")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onLogin}>
                        {t("common.iamsmart.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                BackdropComponent={Backdrop}
            >
                {step == "qrLink" && (
                    <>
                        <DialogContent>
                            <DialogContentText>
                                {t("common.iamsmart.authen.title")}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onCancel}>
                                {t("common.iamsmart.authen.cancel")}
                            </Button>
                        </DialogActions>
                    </>
                )}
                {step == "getProfile" && (
                    <>
                        <DialogTitle>
                            {t("common.iamsmart.linkup.sectionTitle")}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                {t("common.iamsmart.linkup.description")}
                            </DialogContentText>
                            <DialogContentText>
                                <ul>
                                    {t("common.iamsmart.linkup.criteria", {
                                        returnObjects: true,
                                    }).map((criteria, index) => (
                                        <li key={index}>{criteria}</li>
                                    ))}
                                </ul>
                            </DialogContentText>
                        </DialogContent>

                        <DialogActions>
                            {!noSigning && (
                                <Button
                                    variant="contained"
                                    classes={{
                                        root: iamSmartBtnClasses.root,
                                    }}
                                    startIcon={
                                        <img
                                            className="iamSmartPhone"
                                            src={iamsmartIconDark}
                                            alt="i am smart icon"
                                        />
                                    }
                                    className="iamSmartButton"
                                    onClick={onGetProfile}
                                >
                                    <div style={{ fontSize: "12px" }}>
                                        {t(
                                            "common.iamsmart.linkup.provideDataToIamsmart"
                                        )}
                                    </div>
                                </Button>
                            )}
                            {noSigning && (
                                <Typography style={{ color: "red" }}>
                                    {t("common.iamsmart.noSigning")}
                                </Typography>
                            )}
                            <Button onClick={onCancel}>
                                {t("common.iamsmart.linkup.cancel")}
                            </Button>
                        </DialogActions>
                    </>
                )}
                {step == "getProfileResult" && (
                    <>
                        <DialogContent>
                            <DialogContentText>
                                {noSigning && (
                                    <Typography style={{ color: "red" }}>
                                        {t("common.iamsmart.noSigning")}
                                    </Typography>
                                )}
                            </DialogContentText>
                        </DialogContent>
                    </>
                )}
            </Dialog>
        </>
    );
}
